/**
 * Create store system routing-static
 *
 * @since 2018-07-23
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // static routing
    staticRoutings: `${smApiPrefix}/ipv6/static-routings`,
    dynamicRoutings: `${smApiPrefix}/ipv6/dynamic-routings`,
    directRoutings: `${smApiPrefix}/ipv6/direct-routings`
  },
  // CRUD state.
  selectedItem: {},
  selectedPopupItem: {},
  // get staticRouting list.(192.168.191.254 - 0:0:0:0:0:ffff:c0a8:bffe)
  staticRouting: {
    // gui attributes
    id: 0, //           id
    type: 0, //         default gateway: 0, network gateway: 1
    dest_addr: '', //   destination address(default:0:0:0:0:0:ffff:0:0/1, IPv6 Address)
    dest_mask: 1, //    destination address mask(1~128)
    metric: 1, //       metric(1~256)
    gw_addr: null, //   gateway address
    desc: '', //        description
    // cli attributes
    gw_ifc_id: 0, //    gateway interface(from cli)
    gw_ifc_name: '', // gateway interface name(from cli)
    flags: '' //        flag( from cli )
  },
  staticRoutingList: [],
  dynamicRouting: {
    id: 0,
    dest: '', //      목적지(ipv6/mask)
    metric: 0, //     메트릭
    flags: '', //     플래그
    gw: '', //        게이트웨이(IPv6)
    ifc_name: '' //   인터페이스
  },
  dynamicRoutingList: [],
  directRouting: {
    id: 0,
    dest: '', //      목적지(ipv4/mask)
    metric: 0, //     메트릭
    flags: '', //     플래그
    gw: '', //        게이트웨이(IPv4)
    ifc_name: '' //   인터페이스
  },
  directRoutingList: []
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  // reset list
  resetStaticRoutingList (state) {
    state.staticRoutingList = []
  },
  resetDynamicRoutingList (state) {
    state.dynamicRoutingList = []
  },
  resetDirectRoutingList (state) {
    state.directRoutingList = []
  },
  // set list
  setStaticRoutingList (state, data) {
    if (data !== undefined && data.length > 0) {
      state.staticRoutingList = data
    }
  },
  setDynamicRoutingList (state, data) {
    if (data !== undefined && data.length > 0) {
      state.dynamicRoutingList = data
    }
  },
  setDirectRoutingList (state, data) {
    if (data !== undefined && data.length > 0) {
      state.directRoutingList = data
    }
  },
  // add & edit & delete static routing
  addStaticRoutingList (state, item) {
    if (item !== undefined) {
      state.staticRoutingList.push(item)
    }
  },
  edtStaticRoutingList (state, item) {
    const findRslt = _.find(state.staticRoutingList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.staticRoutingList.splice(_.findIndex(state.staticRoutingList, state.selectedItem), 1, item)
    }
  },
  delStaticRoutingList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.staticRoutingList.splice(item.itemIndex, 1)
      }
    }
  },
  // set dialog
  clearStaticRoutingEntryDialog (state) {
    state.staticRouting.id = 0
    state.staticRouting.type = 0
    state.staticRouting.dest_addr = ''
    state.staticRouting.dest_mask = 0
    state.staticRouting.metric = 1
    state.staticRouting.desc = ''
    state.staticRouting.flags = ''
    state.staticRouting.gw_addr = null
    state.staticRouting.gw_ifc_id = 0
    state.staticRouting.gw_ifc_name = ''
  },
  setStaticRoutingEntryDialog (state, item) {
    if (item !== undefined) {
      state.staticRouting.id = item.id
      state.staticRouting.type = item.type
      state.staticRouting.dest_addr = item.dest_addr
      state.staticRouting.dest_mask = item.dest_mask
      state.staticRouting.metric = item.metric
      state.staticRouting.desc = item.desc
      state.staticRouting.flags = item.flags
      state.staticRouting.gw_addr = item.gw_addr
      state.staticRouting.gw_ifc_id = item.gw_ifc_id
      state.staticRouting.gw_ifc_name = item.gw_ifc_name
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> static routing
  async getStaticRoutingList ({commit, state}, loadingOpt) {
    const res = {code: 'nok'}
    commit('resetStaticRoutingList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['staticRoutings'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // commit for staticRouting
      commit('setStaticRoutingList', result)
    }
    return res
  },
  async addStaticRoutingData ({commit, state}) {
    const addParam = {
      type: state.staticRouting.type,
      gw_addr: state.staticRouting.gw_addr
    }
    if (state.staticRouting.type === 1) {
      addParam.dest_addr = state.staticRouting.dest_addr
      addParam.dest_mask = Number(state.staticRouting.dest_mask)
      addParam.metric = state.staticRouting.metric
      addParam.desc = state.staticRouting.desc
    }
    const {code, result} = await this.$axios.$post(state.apiUrlPath['staticRoutings'], addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addStaticRoutingList', result)
      return true
    } else {
      return false
    }
  },
  async delStaticRoutingList  ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${state.apiUrlPath['staticRoutings']}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(state.apiUrlPath['staticRoutings'], {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delStaticRoutingList', param.itemIndexList)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> dynamic routing
  async getDynamicRoutingList ({commit, state}, loadingOpt) {
    const res = {code: 'nok'}
    commit('resetDynamicRoutingList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['dynamicRoutings'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // commit for dynamicRouting
      commit('setDynamicRoutingList', result)
    }
    return res
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> direct routing
  async getDirectRoutingList ({commit, state}, loadingOpt) {
    const res = {code: 'nok'}
    commit('resetDirectRoutingList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['directRoutings'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // commit for directRouting
      commit('setDirectRoutingList', result)
    }
    return res
  }
}

export const getters = {
}

export const strict = false
